module.exports = __webpack_public_path__ + "img/2024-03-08b_1.299023b4.jpg";